import { ZooplaPeak22767 } from '@zoopla/assets';

import { GetHomeWorthEstimateForm } from '@zoopla/home-worth-estimate-form';
import { PageSubtitleShort } from '@zoopla-eng/zds-components/headings';
import { Box } from '@zoopla-eng/zds-components/box';
import {
    descriptionStyle,
    imageStyle,
    mainContentStyle,
    wrapperStyle
} from './HowMuchIsMyHomeWorth.styles.css';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';

const headlineText = 'Ready to move on?';
const descriptionText =
    'Get our latest estimate on your property. You might be surprised what you could get for it.';

const dimensions = { width: 1300, height: 776 };

export const HowMuchIsMyHomeWorth = () => {
    return (
        <div className={wrapperStyle}>
            <img
                className={imageStyle}
                src={ZooplaPeak22767}
                width={dimensions.width}
                height={dimensions.height}
                alt=""
                loading="lazy"
            />
            <div className={mainContentStyle}>
                <Box pb="S200">
                    <PageSubtitleShort
                    // id="home-values-title"
                    >
                        {headlineText}
                    </PageSubtitleShort>
                </Box>
                <p className={`${descriptionStyle} ${fontGroups.whisk}`}>
                    {descriptionText}
                </p>
                <GetHomeWorthEstimateForm
                    eventCategory="homepage"
                    labelId="home-values-title"
                />
            </div>
        </div>
    );
};
